import { SvgIcon } from '@mui/material';

const FinanceMode = (props: any)=>(
    <SvgIcon>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.21053 9.78478V3.35958H6.73684V9.78478L5.47368 8.60892L4.21053 9.78478ZM8.42105 11.0446V0H10.9474V8.52493L8.42105 11.0446ZM0 13.9423V6.71916H2.52632V11.4226L0 13.9423ZM0 16L5.43158 10.5827L8.42105 13.1444L13.1368 8.44095H11.7895V6.76116H16V10.9606H14.3158V9.6168L8.50526 15.4121L5.51579 12.8504L2.35789 16H0Z" fill="#DCCBB2"/>
        </svg>
    </SvgIcon> 
)

export {FinanceMode}